import { Link } from 'braid-design-system';
import type { MouseEvent, PropsWithChildren, FunctionComponent } from 'react';

import { useTracking } from '../../../hooks/useTracking';

export enum TrackingOrigins {
  TRACKING_ORIGIN_HEADER = 'global-header',
  TRACKING_ORIGIN_FOOTER = 'global-footer',
}

interface GlobalTrackingLinkProps {
  href?: string;
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
  ['data-analytics']?: string;
  ['data-analytics-origin']?: string;
}

export const GlobalTrackingLink: FunctionComponent<
  PropsWithChildren<GlobalTrackingLinkProps>
> = ({ href, onClick, ...props }) => {
  const trackingEventName = props['data-analytics'];
  const trackingActionOrigin =
    props['data-analytics-origin'] ?? 'unknown action origin';

  const { trackEvent } = useTracking();

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (trackingEventName) {
      trackEvent(trackingEventName, { actionOrigin: trackingActionOrigin });
    }

    onClick?.(event);
  };

  if (!href) {
    return null;
  }

  return <Link {...props} href={href} onClick={handleClick} />;
};

export const trackLinkRenderer =
  (
    linkOrigin: TrackingOrigins,
  ): FunctionComponent<PropsWithChildren<GlobalTrackingLinkProps>> =>
  (rendererProps: PropsWithChildren<GlobalTrackingLinkProps>) =>
    (
      <GlobalTrackingLink
        {...rendererProps}
        data-analytics-origin={linkOrigin}
      />
    );
